document.addEventListener("DOMContentLoaded", () => {
  // Show Modal
  const openModalButton = document.getElementById("open-modal");
  const modalWindowOverlay = document.getElementById("modal-overlay");

  const showModalWindow = () => {
    modalWindowOverlay.style.display = "flex";
  };
  openModalButton.addEventListener("click", showModalWindow);

  // Hide Modal
  const closeModalButton = document.getElementById("close-modal");

  const hideModalWindow = () => {
    modalWindowOverlay.style.display = "none";
  };

  closeModalButton.addEventListener("click", hideModalWindow);

  // Hide On Blur
  const hideModalWindowOnBlur = (e) => {
    if (e.target === e.currentTarget) {
      console.log(e.target === e.currentTarget);
      hideModalWindow();
    }
  };

  // Show Mobile Modal
  const openMobileModalButton = document.getElementById("open-mobile-modal");
  const modalMobileWindowOverlay = document.getElementById(
    "modal-mobile-overlay"
  );

  if (openMobileModalButton && modalMobileWindowOverlay) {
    const showMobileModalWindow = () => {
      modalMobileWindowOverlay.style.display = "flex";
    };
    openMobileModalButton.addEventListener("click", showMobileModalWindow);

    // Hide On Blur
    const hideMobileModalWindowOnBlur = (e) => {
      if (e.target === e.currentTarget) {
        console.log(e.target === e.currentTarget);
        hideMobileModalWindow();
      }
    };

    modalMobileWindowOverlay.addEventListener(
      "click",
      hideMobileModalWindowOnBlur
    );
  } else {
    console.error("Mobile modal elements are not found in the DOM.");
  }
});
